const Container = ({ children }) => {
  return <main className="lg:max-w-7xl lg:mx-auto">{children}</main>;
};

export default Container;
